import * as api from '@gitbook/api-client';
import { Description, DialogRoot } from '@gitbook/spine-react';

import { useSiteContext } from '../../../../state';
import { AdsRequestReviewDialog } from './AdsRequestReviewModal';
import { AdsAllStatusIndicator } from './AdsStatus';

/**
 * Settings for ads.
 */
export function AdsSettings() {
    const { site, organizationId } = useSiteContext();

    const description = (() => (
        <>
            Generate revenue from your Sponsored site through ethical, relevant advertisements from
            our partners.
        </>
    ))();

    return (
        <div className="flex flex-col gap-6">
            <Description>{description}</Description>
            {site.ads && site.ads.status !== api.SiteAdsStatus.Disabled ? (
                <DialogRoot>
                    <AdsAllStatusIndicator
                        organizationId={organizationId}
                        site={site}
                        ads={site.ads}
                    />

                    <AdsRequestReviewDialog organizationId={organizationId} site={site} />
                </DialogRoot>
            ) : null}
        </div>
    );
}
